import { Component, OnInit } from '@angular/core';
import { ClientUpdateService } from './shared/services/client-update.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DictionaryService, ThemeService } from '@shared/services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(
    updateService: ClientUpdateService,
    private router: Router,
    private translateService: TranslateService,
    private dictionryService: DictionaryService,
    private themeService: ThemeService, //do not remove, needed to set initial theme
  ) { }
  ngOnInit() {
    document.getElementById('loadingSign').style.display = 'none';
  }
}
